import React, { useEffect, useState } from 'react'
import avatar from '../../../Assets/avatar.png';
import Form from 'react-bootstrap/Form';
import Navbar from 'react-bootstrap/Navbar';
import { AiOutlineSearch } from "react-icons/ai";
import { Container, InputGroup } from 'react-bootstrap';
import { AiOutlineBars } from "react-icons/ai"
import { IoMdNotificationsOutline } from "react-icons/io"
import "./NavBar.css";


function NavBar() {
  

  return (
    <Navbar expand="lg" className="nav-bar max-hw-100 mb-5" fixed="top" >
       <Container fluid>
           <Navbar.Brand href="#home"></Navbar.Brand>
          
           <div className='notttif'>
             <IoMdNotificationsOutline  className='apled'/>
           </div>
           <div className=''>
             <div className='applod'>
               <div className="dropdown">
                 <button className="dropbtn">
                   <img src={avatar} alt='zlogo' />
                 </button>
                 <div className="dropdown-content">
                   <a href="#">Profile</a>
                   <a href="#">Parameter</a>
                   <a href="#">Deconnection</a>
                 </div>
               </div>
             </div>
           </div>
         </Container>
    </Navbar>
  );
};

export default NavBar;
